import { type EngineeringTeamKey, engineeringTeams } from './engineering-teams';

/** Resolves a team key to its Datadog team tag, or returns the key unchanged if not found. */
export function getDatadogTeamTag(key: EngineeringTeamKey | (string & {})): string {
  for (const team of Object.values(engineeringTeams)) {
    if (team.key === key) {
      return team.datadog.teamTag;
    }
  }
  return key;
}
